import { Check, X } from "lucide-react";
import { useSiteT } from "../../hooks/useSiteT";

const ROWS = {
    tr: [
        { feature: "Günlük spend kapasitesi", skala: "Yüksek kapasite", trad: "$50 – $250" },
        { feature: "Fonlama modeli", skala: "Adrise operasyon + stablecoin", trad: "Sadece kart / havale" },
        { feature: "Operasyon sürekliliği", skala: "Whitelisted süreç", trad: "Değişken" },
        { feature: "Güven katmanı", skala: "Platinum HIVA Partner", trad: "Standart / Bronze" },
        { feature: "Aylık abonelik", skala: "Yok — $0", trad: "Çoğunlukla sabit aylık ücret" },
        { feature: "White-hat adspend fee", skala: "%4 → %2 (hacim bazlı)", trad: "Gizli maliyet + chargeback riski" },
        { feature: "Performance vertical fee", skala: "%7 → %3 (hacim bazlı)", trad: "Çoğunlukla reddedilir" },
        { feature: "$1M üstü cashback", skala: "%0.5–2 aylık", trad: false },
        { feature: "Ortalama reklam onay süresi", skala: "5 dakika", trad: "5 – 12 saat" },
        { feature: "Kesinti sonrası geçiş", skala: "Hızlı + bakiye aktarımı", trad: "Bakiye kaybı" },
        { feature: "Doğrudan platform temsilcisi", skala: true, trad: false },
        { feature: "Dikeye özel süreçler", skala: "Politika kapsamında", trad: false },
        { feature: "Çoklu performans dikeyi", skala: true, trad: false },
        { feature: "7/24 WhatsApp & Telegram desteği", skala: true, trad: false },
    ],
    en: [
        { feature: "Daily spend capacity", skala: "High capacity", trad: "$50 – $250" },
        { feature: "Funding model", skala: "Adrise operations + stablecoin", trad: "Card / wire only" },
        { feature: "Operational continuity", skala: "Whitelisted process", trad: "Variable" },
        { feature: "Trust tier", skala: "Platinum HIVA Partner", trad: "Standard / Bronze" },
        { feature: "Monthly subscription", skala: "None — $0", trad: "Usually a fixed monthly fee" },
        { feature: "White-hat adspend fee", skala: "4% → 2% (volumetric)", trad: "Hidden costs + chargeback risk" },
        { feature: "Performance vertical fee", skala: "7% → 3% (volumetric)", trad: "Often rejected" },
        { feature: "Cashback above $1M", skala: "0.5–2% monthly", trad: false },
        { feature: "Average ad approval time", skala: "5 minutes", trad: "5 – 12 hours" },
        { feature: "Recovery after disruption", skala: "Fast + balance transfer", trad: "Balance loss risk" },
        { feature: "Direct platform rep access", skala: true, trad: false },
        { feature: "Vertical-specific workflows", skala: "Policy dependent", trad: false },
        { feature: "Multi-vertical performance support", skala: true, trad: false },
        { feature: "24/7 WhatsApp & Telegram support", skala: true, trad: false },
    ],
    es: [
        { feature: "Capacidad de gasto diario", skala: "Alta capacidad", trad: "$50 – $250" },
        { feature: "Modelo de financiación", skala: "Operaciones Adrise + stablecoin", trad: "Solo tarjeta / transferencia" },
        { feature: "Continuidad operativa", skala: "Proceso whitelisted", trad: "Variable" },
        { feature: "Nivel de confianza", skala: "Platinum HIVA Partner", trad: "Estándar / Bronze" },
        { feature: "Suscripción mensual", skala: "Ninguna — $0", trad: "Normalmente cuota fija mensual" },
        { feature: "Comisión white-hat", skala: "4% → 2% (por volumen)", trad: "Costes ocultos + riesgo de chargeback" },
        { feature: "Comisión verticales performance", skala: "7% → 3% (por volumen)", trad: "A menudo rechazadas" },
        { feature: "Cashback por encima de $1M", skala: "0.5–2% mensual", trad: false },
        { feature: "Tiempo medio de aprobación de anuncios", skala: "5 minutos", trad: "5 – 12 horas" },
        { feature: "Recuperación tras una interrupción", skala: "Rápida + traspaso de saldo", trad: "Riesgo de perder saldo" },
        { feature: "Acceso directo a representante de la plataforma", skala: true, trad: false },
        { feature: "Flujos específicos por vertical", skala: "Según política", trad: false },
        { feature: "Soporte multi-vertical performance", skala: true, trad: false },
        { feature: "Soporte 24/7 por WhatsApp y Telegram", skala: true, trad: false },
    ],
    pt: [
        { feature: "Capacidade de gasto diário", skala: "Alta capacidade", trad: "$50 – $250" },
        { feature: "Modelo de financiamento", skala: "Operações Adrise + stablecoin", trad: "Só cartão / transferência" },
        { feature: "Continuidade operacional", skala: "Processo whitelisted", trad: "Variável" },
        { feature: "Nível de confiança", skala: "Platinum HIVA Partner", trad: "Padrão / Bronze" },
        { feature: "Assinatura mensal", skala: "Nenhuma — $0", trad: "Geralmente taxa fixa mensal" },
        { feature: "Taxa white-hat", skala: "4% → 2% (por volume)", trad: "Custos ocultos + risco de chargeback" },
        { feature: "Taxa verticais performance", skala: "7% → 3% (por volume)", trad: "Frequentemente recusadas" },
        { feature: "Cashback acima de $1M", skala: "0.5–2% mensal", trad: false },
        { feature: "Tempo médio de aprovação de anúncios", skala: "5 minutos", trad: "5 – 12 horas" },
        { feature: "Recuperação após interrupção", skala: "Rápida + transferência de saldo", trad: "Risco de perder saldo" },
        { feature: "Acesso direto a representante da plataforma", skala: true, trad: false },
        { feature: "Fluxos específicos por vertical", skala: "Conforme a política", trad: false },
        { feature: "Suporte multi-vertical performance", skala: true, trad: false },
        { feature: "Suporte 24/7 por WhatsApp e Telegram", skala: true, trad: false },
    ],
    ru: [
        { feature: "Дневной лимит расхода", skala: "Высокая ёмкость", trad: "$50 – $250" },
        { feature: "Модель финансирования", skala: "Операции Adrise + стейблкоины", trad: "Только карта / перевод" },
        { feature: "Операционная непрерывность", skala: "Whitelisted-процесс", trad: "Нестабильно" },
        { feature: "Уровень доверия", skala: "Platinum HIVA Partner", trad: "Стандарт / Bronze" },
        { feature: "Ежемесячная подписка", skala: "Нет — $0", trad: "Обычно фиксированная плата в месяц" },
        { feature: "Комиссия white-hat", skala: "4% → 2% (по объёму)", trad: "Скрытые расходы + риск чарджбэков" },
        { feature: "Комиссия performance-вертикалей", skala: "7% → 3% (по объёму)", trad: "Часто отказывают" },
        { feature: "Кэшбэк свыше $1M", skala: "0.5–2% в месяц", trad: false },
        { feature: "Среднее время одобрения рекламы", skala: "5 минут", trad: "5 – 12 часов" },
        { feature: "Восстановление после сбоя", skala: "Быстро + перенос баланса", trad: "Риск потери баланса" },
        { feature: "Прямой доступ к менеджеру платформы", skala: true, trad: false },
        { feature: "Процессы под вертикаль", skala: "По политике", trad: false },
        { feature: "Поддержка нескольких performance-вертикалей", skala: true, trad: false },
        { feature: "Поддержка 24/7 в WhatsApp и Telegram", skala: true, trad: false },
    ],
};

function Cell({ value, accent = false }) {
    if (value === true)
        return (
            <span className="inline-flex items-center gap-2 text-foreground">
                <Check className={`w-4 h-4 ${accent ? "text-primary" : "text-foreground/50"}`} />
            </span>
        );
    if (value === false)
        return (
            <span className="inline-flex items-center gap-2 text-muted-foreground">
                <X className="w-4 h-4" />
            </span>
        );
    return <span className={`text-sm ${accent ? "text-foreground font-medium" : "text-muted-foreground"}`}>{value}</span>;
}

export default function ComparisonTable() {
    const { t, pick } = useSiteT();
    const rows = pick(ROWS);

    return (
        <section id="compare" data-testid="comparison-section" className="py-24 md:py-32">
            <div className="container-skala">
                <div className="max-w-3xl mb-12 space-y-4">
                    <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-highlight">{t("cmp.eyebrow")}</p>
                    <h2 className="font-display font-semibold text-4xl md:text-5xl tracking-tight">
                        {t("cmp.h1")}{" "}
                        <span className="serif-accent text-foreground/85">Adrise</span>{t("cmp.h2")}
                    </h2>
                </div>

                <div className="rounded-2xl border border-white/[0.08] overflow-hidden">
                    <div className="grid grid-cols-3 bg-white/[0.02] border-b border-white/[0.06]">
                        <div className="p-5 text-xs font-mono uppercase tracking-[0.2em] text-muted-foreground">{t("cmp.feature")}</div>
                        <div className="p-5 text-sm md:text-base font-display font-bold tracking-wide text-primary border-l border-white/[0.06]">Adrise</div>
                        <div className="p-5 text-sm md:text-base font-display font-medium tracking-wide text-muted-foreground border-l border-white/[0.06]">{t("cmp.trad")}</div>
                    </div>

                    {rows.map((r, i) => (
                        <div key={r.feature} data-testid={`compare-row-${i}`} className={`grid grid-cols-3 ${i !== rows.length - 1 ? "border-b border-white/[0.05]" : ""}`}>
                            <div className="p-5 text-sm text-foreground/85">{r.feature}</div>
                            <div className="p-5 border-l border-white/[0.05] bg-primary/[0.025]">
                                <Cell value={r.skala} accent />
                            </div>
                            <div className="p-5 border-l border-white/[0.05]">
                                <Cell value={r.trad} />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
